let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("64QTa")).then(() => parcelRequire('gbtl7'));